/* template */
<template minapp="mpx" xlang="wxml"><div class="scramble-select-card"><div class="scramble-select-card-header"><div class="station-info"><span>{{ curTrainInfo?.from_station_name }}</span><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/jsgPNCkSw01692184982568.png" class="arrow-icon"/><span>{{ curTrainInfo?.to_station_name }}</span></div><div class="other-info">{{ totalInfo }}</div></div><div class="train-number-select card-item"><div class="title">备选车次</div><mpx-view @tap="goToSelectTrain" class="train-number-empty" v-if="(!trainCodeList.length)">建议多选</mpx-view><mpx-view @tap="goToSelectTrain" class="train-number-select-item" v-else>{{ trainCodeList.join(' ') }}</mpx-view><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/8x2zppExzh1692076532321.png" @tap="goToSelectTrain" class="right-arrow"/></div><div class="date-select card-item"><div class="title"><span>备选日期</span><span class="suggest-text">建议多选</span></div><div class="date-item-container"><mpx-view :class="({'date-item-selected': item.isSelect})" v-for="(item, index) in (refactorDateList)" :key="item.index" @tap="setSelectDateCurList(index)" :style="[(item.style)] | transRpxStyle" class="date-item"><div class="date-day">{{ item.day }}</div><div class="date-week date-week-selected">{{ item.week }}</div><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/xMLmuwUob91692098509356.png" class="select-icon" v-if="(item.isSelect)"/></mpx-view></div></div><div class="seat-select card-item"><div class="title"><span>备选座席</span><span class="suggest-text">建议多选</span></div><div ref="__mpx_ref_seatref__" class="seat-select-item-container"><mpx-view :class="({'seat-select-item-selected':item.isSelect})" v-for="(item, index) in (refactorSeatList)" :key="item.index" :style="[(item.style)] | transRpxStyle" @tap="setSelectSeatCodeList(item.seat_name)" class="seat-select-item"><div class="seat-name">{{ item.seat_name }}</div><div class="seat-price">{{ '¥' + item.highest_ticket_price / 100 }}</div><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/xMLmuwUob91692098509356.png" class="select-icon" v-if="(item.isSelect)"/><div :class="({'circle-selected':item.isSelect})" class="circle left"></div><div :class="({'circle-selected':item.isSelect})" class="circle right"></div></mpx-view></div></div><div class="deadline-select card-item"><div class="title">截止时间</div><mpx-view @tap="openDeadLine" class="deadline-text">发车前{{ deadLineText }}小时</mpx-view><mpx-image src="https://img-hxy021.didistatic.com/static/starimg/img/8x2zppExzh1692076532321.png" @tap="openDeadLine" class="right-arrow"/></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m279e998f"}'>
  .scramble-select-card
    width 100%
    display flex
    flex-direction column
    background #fff
    box-sizing border-box
    border-radius 12px 30px 12px 12px
    position relative
    &-header
      margin 0 11px 4.5px 11px
      padding 20px 0
      box-sizing border-box
      display flex
      flex-direction column
      justify-content center
      border-bottom 0.5px solid rgba(209, 219, 233, 0.6)
      .station-info
        display flex
        height 20px
        font-family PingFangSC-Semibold
        font-size 20px
        line-height 20px
        color #000
        align-items center
        .arrow-icon
          height 5px
          width 18px
          margin-left 8px
          margin-right 6px
      .other-info
        margin-top 8px
        font-family PingFangSC-Regular
        font-size 14px
        line-height 14px
        color #999
    .card-item
      display flex
      align-items center
      position relative
      flex-wrap nowrap
      white-space nowrap
      margin-left 11px
      .title
        display flex
        flex-direction column
        font-family PingFangSC-Regular
        font-size 14px
        color #333
        margin-right 24px
        .suggest-text
          font-size 10px
          color #999
          margin-top 4px
          line-height 10px
      .right-arrow
        height 16px
        width 16px
        position absolute
        right 8px
    .train-number-select
      font-family PingFangSC-Medium
      font-size 14px
      line-height 14px
      color #000000
      padding 17px 8px 19px 0px
      .train-number-empty
        flex 1
        color #999
        font-family PingFangSC-Regular
      &-item
        overflow auto
        margin-right 24px
    .date-select
      .date-item-container
        flex 1
        display flex
        .date-item
          height 44px
          width 44px
          display flex
          flex-direction column
          justify-content center
          align-items center
          border-radius 6px
          box-sizing border-box
          position relative
          &:after
            position absolute
            content ''
            width 200%
            height 200%
            border 1px solid var(--after)
            transform-origin 0 0
            transform scale(0.5)
            border-radius 12px
            top 0
            left 0
          &:not(:last-child)
            margin-right 6px
          .date-day
            font-family PingFangSC-Medium
            font-size 14px
            line-height 14px
            color #333
            margin-bottom 4px
          .date-week
            font-family PingFangSC-Regular
            font-size 10px
            line-height 10px
            color #666
            &-selected
              color #000
          &-selected
            border 1px solid #FF5900
    .seat-select
      padding 20px 0 9px 0px
      .seat-select-item-container
        flex 1
        display flex
        overflow auto
        white-space nowrap
        flex-wrap nowrap
        .seat-select-item
          flex-shrink 0
          width 56px
          height 44px
          display flex
          flex-direction column
          justify-content center
          align-items center
          border-radius 6px
          box-sizing border-box
          position relative
          overflow hidden
          font-size 12px
          mask radial-gradient(circle at 3.1px, #0000 3.1px, red 0) -3.1px
          -webkit-mask radial-gradient(circle at 3.1px, #0000 3.1px, red 0) -3.1px
          margin-right 6px
          &:after
            position absolute
            content ''
            width 200%
            height 200%
            box-sizing border-box
            border 1px solid var(--seatafter)
            transform-origin 0 0
            transform scale(0.5)
            border-radius 12px
            top 0
            left 0
          &-selected
            border 1px solid #FF5900
          .seat-name
            font-family PingFangSC-Medium
            font-size 12px
            line-height 14px
            color #000
            margin-bottom 4px
          .seat-price
            font-family PingFangSC-Regular
            font-size 10px
            line-height 10px
            color #666
            &-selected
              color #000
          .circle
            content ''
            position absolute
            background #fff
            width 6px
            height 6px
            border-radius 50%
            border 0.6px solid #D1DBE9
            top 50%
            transform translateY(-50%)
            &.left
              left -3.3px
            &.right
              right -3.3px
            &-selected
              border 1px solid #FF5900
    .deadline-select
      padding 11px 0 18px 0
      box-sizing border-box
      line-height 14px
      .deadline-text
        flex 1
        font-family PingFangSC-Medium
        font-size 14px
        line-height 14px
        color #000
    .scramble-select-description
      display flex
      align-items center
      height 38px
      width 100%
      background linear-gradient(0deg, #F6F8FA, #F6F8FA), linear-gradient(270deg, #FFFFFF 3%, #FFF3EB 100%)
      box-sizing border-box
      border 2px solid #fff
      border-radius 0 0 12px 12px
      padding-left 16px
      .description-icon
        height 16px
        width 16px
        margin-right 4px
      .description-text
        font-family PingFangSC-Regular
        font-size 12px
        line-height 14px
        color #333
  .select-icon
    height 10px
    width 12px
    position absolute
    bottom 0
    right 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m279e998f"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./scramble-select-card.mpx.js?isComponent&outputPath=components%2Fscramble-select-card279e998f%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./scramble-select-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fscramble-select-card279e998f%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m279e998f"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/scramble-select-card279e998f/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
